<template>
    <v-app>
        <eps-login-header></eps-login-header>
        <v-content>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-container class="fill-height" fluid>
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="8" md="5">
                        <v-card class="elevation-12">
                            <v-toolbar class="app" dark flat>
                                <v-toolbar-title>Forgot Password</v-toolbar-title>
                                <v-spacer />
                            </v-toolbar>
                            <v-overlay :value="overlay">
                                <v-progress-circular indeterminate size="64"></v-progress-circular>
                            </v-overlay>
                            <v-card-text>
                                <v-form>
                                    <v-text-field
                                        v-model="user.uid"
                                        prepend-icon="email"
                                        placeholder="Enter your login id"
                                        clearable
                                        :hint="
                      disabled == 1
                        ? 'noneditable'
                        : 'Enter your login username'
                    "
                                        :disabled="disabled == 1 ? true : false"
                                        required
                                    ></v-text-field>
                                    <v-text-field
                                        type="number"
                                        id="enterOTP"
                                        v-if="hidden1"
                                        v-model="user.otp"
                                        :rules="[(v) => !!v || 'OTP is required']"
                                        prepend-icon="mdi-email-open"
                                        placeholder="Enter your otp"
                                        min="1"
                                        max="6"
                                        clearable
                                        hint="Please check your mail & enter otp."
                                        @change="btndisabled"
                                        required
                                    ></v-text-field>
                                    <!-- New Layout instead of page routing -->
                                    <v-text-field
                                        id="newpwd"
                                        v-if="hidden1"
                                        v-model="newpwd"
                                        prepend-icon="mdi-lock"
                                        placeholder="Create new Password"
                                        clearable
                                        :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append="() => (value = !value)"
                                        :type="value ? 'password' : 'text'"
                                        hint="Combination of Numbers, alphabets and characters is recommended"
                                        required
                                    ></v-text-field>
                                    <v-text-field
                                        id="cnfmpwd"
                                        v-if="hidden1"
                                        v-model="cnfmpwd"
                                        prepend-icon="mdi-lock"
                                        placeholder="Re Enter new Password"
                                        clearable
                                        :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append="() => (value = !value)"
                                        :type="value ? 'password' : 'text'"
                                        hint="Re enter your new password"
                                        required
                                    ></v-text-field>
                                    <div v-if="hidden1" class="captcha-container">
                                        <img :src="captchaImage" @click="loadCaptcha" class="captcha-image" />
                                        <v-row align="center" no-gutters class="captcha-row">
                                            <v-col cols="8">
                                                <v-text-field
                                                    v-model="userCaptcha"
                                                    placeholder="Enter CAPTCHA"
                                                    clearable
                                                    prepend-icon="mdi-shield-check"
                                                    :rules="[(v) => !!v || 'CAPTCHA is required']"
                                                    outlined
                                                    dense
                                                    class="captcha-input"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="4" class="d-flex align-center justify-end">
                                                <v-btn
                                                    color="#1976D2"
                                                    dark
                                                    @click="verifyCaptcha"
                                                    class="captcha-verify-btn"
                                                    small
                                                >
                                                    Verify 
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                        <p v-if="message" :style="{ color: success ? 'green' : 'red' }" class="captcha-message">
                                            {{ message }}
                                        </p>
                                    </div>
                                    <div class="error-message" v-if="error">
                                        {{ error_message }}
                                    </div>
                                    <div style="display: none">
                                        <altcha-widget
                                        ref="altcha"
                                        :challengeurl="challengeUrl"
                                         @statechange="onAltchaStateChange"
                                        ></altcha-widget>
                                    </div>
                                    <v-layout align-center justify-center v-if="hidden">
                                        <v-btn class="mr-4" color="primary" @click="sendotp"> <v-icon>mdi-email-send-outline</v-icon>&nbsp;&nbsp; Send OTP </v-btn>
                                    </v-layout>

                                    <div v-if="hidden" class="mt-2" style="text-align: justify; margin-left: 5%;">
                                        If you are not receiving OTP, please contact school admin to reset the password.
                                    </div>
                                    <div class="error-message" v-if="error1">
                                        {{ error_message1 }}
                                    </div>
                                    <!-- <v-layout align-center justify-center v-if="hidden1">
                      <v-btn class="mr-4" color="primary" @click="verifyotp" :disabled="btnDisabled == true ? true : false">Verify OTP</v-btn>
                  </v-layout>-->
                                    <!-- New layout instead of page routing -->
                                    <v-layout align-center justify-center v-if="hidden1">
                                        <v-btn class="mr-4" color="primary" @click="changeUserPassword" :disabled="btnDisabled == true ? true : false">Change Password</v-btn>
                                    </v-layout>
                                </v-form>
                            </v-card-text>
                            <router-link to="/" style="text-decoration: none;" title="Back">
                                <v-icon large color="grey darken">mdi-chevron-left-circle</v-icon>
                            </router-link>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>
        <eps-login-footer></eps-login-footer>
    </v-app>
</template>

<script>
    import axios from "axios";
    import epsLoginHeader from "./LoginHeader.vue";
    import epsLoginFooter from "./LoginFooter.vue";
    import crypto from "@/service/crypto";
    export default {
        components: {
            epsLoginHeader: epsLoginHeader,
            epsLoginFooter: epsLoginFooter,
        },
        data() {
            return {
                user: {
                    uid: "",
                    otp: "",
                },
                rules: {
                    required: (value) => !!value || "Required.",
                    uid: (value) => {
                        const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        const numberPattern = /^[0-9]{10,}$/;
                        const numberWithCodePattern = /^[0-9]{10,}@[A-Za-z0-9]+$/;
                        if (this.allow_number) {
                            return (
                                emailPattern.test(value) ||
                                numberPattern.test(value) ||
                                numberWithCodePattern.test(value) ||
                                "Enter valid Email / Mobile / UID"
                            );
                        } else {
                            return emailPattern.test(value) || "Invalid e-mail.";
                        }
                    },
                },
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                hidden: true,
                hidden1: false,
                disabled: 0,
                btnDisabled: true,
                message: "",
                successMessage: "",
                dbotp: "",
                error: false,
                error_message: "",
                error1: false,
                error_message1: "",
                overlay: false,
                snackbar_msg: "",
                color: "",
                snackbar: false,
                newpwd: "",
                cnfmpwd: "",
                sent_on: [],
                value: String,
                captchaImage: "",
                captchaToken: "",
                userCaptcha: "",
                success: false,
                allow_number: false,
                altchaPayload: null,
                challengeUrl: "",
                pendingAction: null,
            };
        },
    watch: {
        userCaptcha(newValue) {
            // Clear CAPTCHA-related errors when user types or clears the CAPTCHA field
            if (this.error && (this.error_message === "Please enter CAPTCHA" || this.error_message === "Please verify CAPTCHA")) {
                this.error = false;
                this.error_message = "";
            }
            // Reset success flag if CAPTCHA input changes after verification
            if (this.success && newValue !== this.userCaptcha) {
                this.success = false;
                this.message = "";
            }
        },
    },
        methods: {
            sendotp() {
                let isValid = false;

                if (this.allow_number) {
                    const numberPattern = /^[0-9]{10,}$/;
                    const numberWithCodePattern = /^[0-9]{10,}@[A-Za-z0-9]+$/;

                    isValid =
                        this.reg.test(this.user.uid) ||
                        numberPattern.test(this.user.uid) ||
                        numberWithCodePattern.test(this.user.uid);
                } else {
                    isValid = this.reg.test(this.user.uid);
                }

                if (!this.user.uid || !isValid) {
                    this.error = true;
                    this.error_message = "Please Enter Valid Email ID..";
                    return;
                }

                this.pendingAction = "forgotPassword";
                this.executeAltcha();
            },

            changeUserPassword() {
                this.error = false;
                this.error_message = "";

                if (!this.userCaptcha) {
                    this.error = true;
                    this.error_message = "Please enter CAPTCHA";
                    return;
                }

                if (!this.success) {
                    this.error = true;
                    this.error_message = "Please verify CAPTCHA";
                    return;
                }

                if (!this.perormOtpFormValidation()) {
                    this.showSnackbar("#b71c1c", "Please Enter OTP.");
                    return;
                }

                if (!this.checkBlankPwdFields()) {
                    this.showSnackbar("#b71c1c", "Please provide Password!");
                    return;
                }

                if (!this.matchPwdFields()) {
                    this.showSnackbar("#b71c1c", "Password Doesn't match!");
                    return;
                }

                this.pendingAction = "verifyOTPandChangePassword";
                this.executeAltcha();
            },

            sendForgotPasswordRequest() {
                this.user.dns = window.location.hostname;
                this.overlay = true;

                const payload = {
                    user: this.user,
                    altchaPayload: this.altchaPayload
                };

                const encryptedData = crypto.encrypt(payload);

                axios
                    .post("/login/forgotpassword", { data: encryptedData })
                    .then((res) => {
                        const decryptedResponse = JSON.parse(
                            crypto.decrypt(res.data.data)
                        );

                        if (decryptedResponse.msg == "200") {
                            this.sent_on = decryptedResponse.sent_on;
                            this.showSnackbar(
                                "#4caf50",
                                "OTP has been sent on " + this.sent_on
                            );

                            localStorage.setItem("EPS-uid", decryptedResponse.uid);
                            this.hidden = false;
                            this.hidden1 = true;
                            this.disabled = (this.disabled + 1) % 2;
                            this.dbotp = decryptedResponse.otp;
                        } else if (decryptedResponse.msg == "NAK") {
                            this.error = true;
                            this.error_message = "Invalid Email Id..";
                        } else if (decryptedResponse.msg == "NA") {
                            this.showSnackbar(
                                "#b71c1c",
                                "OTP cannot be sent! Email is not verified!"
                            );
                        } else {
                            this.hidden1 = false;
                            this.showSnackbar("#b71c1c", decryptedResponse.msg);
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        this.showSnackbar("#b71c1c", "Something went wrong");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },

            // sendotp() {
            //     let isValid = false;

            //     if (this.allow_number) {
            //         const numberPattern = /^[0-9]{10,}$/;
            //         const numberWithCodePattern = /^[0-9]{10,}@[A-Za-z0-9]+$/;

            //         isValid =
            //             this.reg.test(this.user.uid) ||
            //             numberPattern.test(this.user.uid) ||
            //             numberWithCodePattern.test(this.user.uid);
            //     } else {
            //         isValid = this.reg.test(this.user.uid);
            //     }
            //     // if (this.user.uid == "" ? "" : this.reg.test(this.user.uid)) {
            //     if (this.user.uid) {
            //         if (this.perormEmailFormValidation()) {
            //             //console.log("I am in If block :: " + this.user.uid);
            //             this.user.dns = window.location.hostname;
            //             this.overlay = true;
            //             const payload = {
            //                 user : this.user
            //             }
            //            const encryptedData = crypto.encrypt(payload);
            //             axios
            //                 .post("/login/forgotpassword", {data: encryptedData})
            //                 // .then((res) => {
            //                 //     const data = JSON.parse(
            //                 //         crypto.decrypt(res.data.data)
            //                 //     );
            //                 //     window.console.log("res" + res.data);
            //                 //     if (res.data.msg == "200") {
            //                 //         this.overlay = false;
            //                 //         this.sent_on = res.data.sent_on;
            //                 //         //this.successMessage=true;
            //                 //         this.showSnackbar("#4caf50", "OTP has been sent on " + this.sent_on); // show snackbar on error
            //                 //         //this.successMessage = "OTP has been sent on your Email";
            //                 //         localStorage.setItem("EPS-uid", res.data.uid);
            //                 //         this.hidden = false;
            //                 //         this.hidden1 = true;
            //                 //         this.disabled = (this.disabled + 1) % 2;
            //                 //         this.dbotp = res.data.otp;
            //                 //     } else if (res.data.msg == "NAK") {
            //                 //         this.overlay = false;
            //                 //         this.message = "Invalid Email Id..";
            //                 //         this.error = true;
            //                 //         this.error_message = "Invalid Email Id..";
            //                 //     } else if (res.data.msg == "NA") {
            //                 //         this.overlay = false;
            //                 //         this.showSnackbar("#b71c1c", "OTP cannot be sent! Email is not verified!");
            //                 //     } else {
            //                 //         this.overlay = false;
            //                 //         this.hidden1 = false;
            //                 //         this.showSnackbar("#b71c1c", res.data.msg);
            //                 //     }
            //                 // })
            //                 .then((res) => {
            //                     const decryptedResponse = JSON.parse(
            //                         crypto.decrypt(res.data.data)
            //                     );

            //                     if (decryptedResponse.msg == "200") {
            //                         this.overlay = false;
            //                         this.sent_on = decryptedResponse.sent_on;
            //                         this.showSnackbar( "#4caf50","OTP has been sent on " + this.sent_on);
            //                         localStorage.setItem("EPS-uid", decryptedResponse.uid);
            //                         this.hidden = false;
            //                         this.hidden1 = true;
            //                         this.disabled = (this.disabled + 1) % 2;
            //                         this.dbotp = decryptedResponse.otp;

            //                     } else if (decryptedResponse.msg == "NAK") {
            //                         this.overlay = false;
            //                         this.message = "Invalid Email Id..";
            //                         this.error = true;
            //                         this.error_message = "Invalid Email Id..";

            //                     } else if (decryptedResponse.msg == "NA") {
            //                         this.overlay = false;
            //                         this.showSnackbar(
            //                             "#b71c1c",
            //                             "OTP cannot be sent! Email is not verified!"
            //                         );

            //                     } else {
            //                         this.overlay = false;
            //                         this.hidden1 = false;
            //                         this.showSnackbar("#b71c1c", decryptedResponse.msg);
            //                     }
            //                 })
            //                 .catch((error) => {
            //                     this.overlay = false;
            //                     window.console.log(error);
            //                     this.message = "Something went wrong";
            //                 })
            //                 .finally(() => {
            //                     this.overlay = false;
            //                 });
            //         } else {
            //             //console.log("I am in else block :: " + this.user.uid);
            //             this.error = true;
            //             this.error_message = "Please Enter Valid Email ID..";
            //         }
            //     } else {
            //         //console.log("I am in else block :: " + this.user.uid);
            //         this.error = true;
            //         this.error_message = "Please Enter Valid Email ID..";
            //     }
            // },
            // verifyotp() {
            //   if (this.perormOtpFormValidation()) {
            //     //console.log("I am in If block :: " + this.user.uid + " :: "+  this.user.otp  + " :: " + this.dbotp);
            //     this.overlay = true;
            //     axios
            //       .post("/login/verifyForgotPasswordOTP", this.user)
            //       .then(res => {
            //         //console.log(res.data);
            //         if (res.data.msg == "YES") {
            //           this.overlay = false;
            //           this.showSnackbar("#4caf50", "OTP verified successfully"); // show snackbar on error
            //           //console.log(res.data);
            //           this.hidden = false;
            //           this.hidden1 = false;
            //         } else if (res.data.msg == "NO") {
            //           this.overlay = false;
            //           this.showSnackbar("#b71c1c", "Wrong OTP! Please try again..."); // show snackbar on error
            //           document.getElementById("enterOTP").value = "";
            //         }
            //       })
            //       .catch(error => {
            //         window.console.log(error);
            //         this.message = "Something went wrong";
            //       })
            //       .finally(() => {
            //         "use strict";
            //         var overlay = false;
            //       });
            //     //
            //     // if(this.user.otp == this.dbotp) {
            //     //   this.hidden = false;
            //     //   this.$router.push("/change-password");
            //     //   //window.location="/change-password";
            //     // } else {
            //     //   this.message = "OTP not Match!!!";
            //     //   this.error1=true;
            //     //   this.error_message1='Please Enter Valid OTP..';
            //     // }
            //   } else {
            //     //console.log("I am in else block :: " + this.user.uid);
            //     this.error1 = true;
            //     this.error_message1 = "Please Enter OTP..";
            //   }
            // },
            async loadCaptcha() {
                try {
                    const url = process.env.VUE_APP_API_URL + `/Captcha/generate?dns=${encodeURIComponent(this.dns)}`;
                    const res = await fetch(url);

                    if (!res.ok) throw new Error(`HTTP ${res.status}`);

                    const data = await res.json();
                    console.log("CAPTCHA:", data);

                    this.captchaImage = data.image;
                    this.captchaToken = data.token;
                    this.userCaptcha = "";
                    this.success = false;
                    this.message = "";
                } catch (err) {
                    console.error("CAPTCHA load error:", err);
                }
            },
            async verifyCaptcha() {
                const url = process.env.VUE_APP_API_URL + `/Captcha/verify?dns=${encodeURIComponent(this.dns)}`;
                const res = await fetch(url, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        token: this.captchaToken,
                        userCaptcha: this.userCaptcha,
                    }),
                });
                const result = await res.json();
                this.message = result.message;
                this.success = result.success;
                if (!result.success) {
                    this.loadCaptcha();
                }
            },
            perormEmailFormValidation() {
                if (this.user.uid == "") {
                    return false;
                } else {
                    return true;
                }
            },
            perormOtpFormValidation() {
                if (this.user.otp == "" && this.user.uid == "") {
                    return false;
                } else {
                    return true;
                }
            },
            btndisabled() {
                this.btnDisabled = false;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            async changePassword() {
            //    const token = await grecaptcha.execute(
            //                   "6LdpJ1orAAAAAIPDCJppHuoZgrMbHDYyGhlYqbrO",
            //                   { action: "submit" }
            //                 );
                //console.log("in changePassword");
                this.error = false;
                this.error_message = '';
                if (!this.userCaptcha) {
                    this.error = true;
                    this.error_message = 'Please enter CAPTCHA';
                    return;
                }
                if (!this.success) {
                    this.error = true;
                    this.error_message = 'Please verify CAPTCHA';
                    return;
                }
                if (this.perormOtpFormValidation()) {
                    if (this.checkBlankPwdFields()) {
                        if (this.matchPwdFields()) {
                            const data = {
                                newpwd: this.newpwd,
                                uid: this.user.uid,
                                otp: this.user.otp,
                                altchaPayload: this.altchaPayload,
                                // token:token
                            };
                            // console.log(data);
                            const encryptedData = crypto.encrypt(data);
                            this.overlay = true;
                            axios.post("/login/verifyOTPandChangePassword", {data: encryptedData})
                            // .then((res) => {
                            //     //console.log(res.data);
                            //     if (res.data.msg == "200") {
                            //         this.overlay = false;
                            //         alert("Password Changed Succussfully...");
                            //         //this.showSnackbar("#4caf50", "Password Changed Succussfully"); // show snackbar on error
                            //         this.sleep(2000);
                            //         this.$router.push("/");
                            //     } 
                            //     else if (res.data.msg == "ONM") {
                            //         this.overlay = false;
                            //         this.showSnackbar("#b71c1c", "Wrong OTP! Please try again..."); // show snackbar on error
                            //         document.getElementById("enterOTP").value = "";
                            //         // console.log(res.data);
                            //     }
                            //     else if (res.data.msg == "AVF") {
                            //         this.overlay = false;
                            //         this.showSnackbar("#b71c1c", "Captcha Verification failed!..."); // show snackbar on error
                            //         document.getElementById("enterOTP").value = "";
                            //     }else{
                            //         this.overlay = false;
                            //         this.showSnackbar("#b71c1c",res.data.msg); 
                            //         document.getElementById("enterOTP").value = "";
                            //     }
                            // });
                            .then((res) => {
                                const response = JSON.parse(crypto.decrypt(res.data.data));
                                if (response.msg == "200") {
                                    this.overlay = false;
                                    alert("Password Changed Successfully...");
                                    this.sleep(2000);
                                    this.$router.push("/");
                                } 
                                else if (response.msg == "ONM") {
                                    this.overlay = false;
                                    this.showSnackbar("#b71c1c", "Wrong OTP! Please try again...");
                                    document.getElementById("enterOTP").value = "";
                                } 
                                else if (response.msg == "AVF") {
                                    this.overlay = false;
                                    this.showSnackbar("#b71c1c", "Captcha Verification failed!...");
                                    document.getElementById("enterOTP").value = "";
                                } 
                                else {
                                    this.overlay = false;
                                    this.hidden1 = false;
                                    this.showSnackbar("#b71c1c", response.msg);
                                    document.getElementById("enterOTP").value = "";
                                }
                            })
                            .catch((error) => {
                                this.overlay = false;
                                console.error(error);
                            });
                        } else {
                            this.overlay = false;
                            this.showSnackbar("#b71c1c", "Password Doesn't match!"); // show snackbar on error
                            document.getElementById("newpwd").value = "";
                            document.getElementById("cnfmpwd").value = "";
                        }
                    } else {
                        this.overlay = false;
                        this.showSnackbar("#b71c1c", "Please provide Password!"); // show snackbar on error
                        document.getElementById("newpwd").value = "";
                        document.getElementById("cnfmpwd").value = "";
                    }
                }
            },
            checkBlankPwdFields() {
                if (this.newpwd == "" && this.cnfmpwd == "") {
                    return false;
                } else {
                    return true;
                }
            },
            matchPwdFields() {
                if (this.newpwd == this.cnfmpwd) {
                    return true;
                } else {
                    return false;
                }
            },
            sleep(milliseconds) {
                const date = Date.now();
                let currentDate = null;
                do {
                    currentDate = Date.now();
                } while (currentDate - date < milliseconds);
            },
            executeAltcha() {
                const altchaEl = this.$refs.altcha;

                if (!altchaEl) {
                    this.pendingAction = null;
                    this.showSnackbar("#b71c1c", "Security verification widget not found.");
                    return;
                }

                this.altchaPayload = null;

                if (typeof altchaEl.reset === "function") {
                    altchaEl.reset();
                }

                this.$nextTick(() => {
                    if (typeof altchaEl.verify === "function") {
                        altchaEl.verify();
                    } else {
                        this.pendingAction = null;
                        this.showSnackbar("#b71c1c", "ALTCHA verification is not available.");
                    }
                });
            },

            onAltchaStateChange(event) {
                const { state, payload } = event.detail;

                if (state === "verified") {
                    this.altchaPayload = payload;

                    if (this.pendingAction === "forgotPassword") {
                        this.pendingAction = null;
                        this.sendForgotPasswordRequest();
                    }else if (this.pendingAction === "verifyOTPandChangePassword") {
                        this.pendingAction = null;
                        this.changePassword();
                    }

                } else if (state === "error") {
                    this.pendingAction = null;
                    this.overlay = false;
                    this.showSnackbar("#b71c1c", "Security verification failed. Please try again.");
                } else if (state === "expired") {
                    this.altchaPayload = null;
                }
            },
        },
        mounted() {
            this.challengeUrl = process.env.VUE_APP_API_URL + "Altcha/challenge";

            this.message = localStorage.getItem("login-page-msg");
            this.dns = window.location.hostname;
            this.loadCaptcha();

            var url = window.location.href;
            this.allow_number = false;
            if (url.includes("school.despune")) {
                this.allow_number = true;
            }
        },
    };
</script>
<style scoped>
    .pull-right {
        position: relative;
        text-align: center;
    }
    .error-message {
        color: red;
        font-size: 14px;
        font-weight: 900;
        padding-left: 7%;
    }
    .v-btn__content {
        display: flex;
        flex-direction: column;
    }
    .app {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }
</style>
